<template>
  <div class="form-content">
    <h6 class="text-center text-secondary mb-0">휴대폰 번호</h6>
    <v-list-item>
      <v-list-item-content>
        <v-text-field
          v-model="userData.loginId"
          :disabled="isAuthorized"
          solo
          placeholder="- 없이 숫자만 입력해 주세요"
          type="tel"
          autofocus
          :rules="[cellRules.required, cellRules.counter, cellRules.check]"
          prepend-inner-icon=""
          class="phone-input"
          @input="onInputPhoneNumber"
        >
          <template v-slot:prepend-inner>
            <span class="country-code">+82</span>
          </template>
        </v-text-field>
        <!-- <p class="step-sub-content">
          - 없이 숫자만 입력해 주세요
        </p> -->
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookies from "js-cookie";
const rulesService = require("@/utils/rules.js");

export default {
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
      cellRules: rulesService.cellRules(),
    };
  },
  computed: {
    ...mapGetters(["isAuthorized", "getThemeMode"]),
    accessInfo() {
      if (!this.isAuthorized) return;
      const CookieName = process.env.VUE_APP_CookieName;
      return JSON.parse(Cookies.get(CookieName));
    },
  },
  methods: {
    onInputPhoneNumber(value) {
      // 숫자만 남기고 나머지 제거
      const onlyDigits = value.replace(/\D/g, '');
      this.userData.loginId = onlyDigits;
    },
  },
};
</script>

<style lang="scss">
.form-content {
  margin-bottom: 10px;
}


.hint-text {
  text-align: left;
  font-size: 12px;
  color: #999;
  margin-left: 12px;
}
</style>
